import { proxyMethod } from '../util/util';
var OverlayBaseController = /** @class */ (function () {
    function OverlayBaseController(ctrl) {
        this.ctrl = ctrl;
    }
    OverlayBaseController.prototype.create = function (opts) {
        return proxyMethod(this.ctrl, 'create', opts);
    };
    OverlayBaseController.prototype.dismiss = function (data, role, id) {
        return proxyMethod(this.ctrl, 'dismiss', data, role, id);
    };
    OverlayBaseController.prototype.getTop = function () {
        return proxyMethod(this.ctrl, 'getTop');
    };
    return OverlayBaseController;
}());
export { OverlayBaseController };
